export const tertiaryOptions = {

  entry: [
    {
      value: 'date',
      label: 'Fecha (Año, mes, dia)',
      usage: "entry | date: '%y, %m, %d'"
    },
    {
      value: 'date-plane',
      label: 'Fecha plana',
      usage: "entry | date: '%s'",
      nb: 'this a year-month'
    }
  ],

};